import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useMutation, useQueryClient } from "react-query";

export const usePersonal = () => {
  const queryClient = useQueryClient();

  const updateName = useMutation(
    ({ contactId, nameData }) =>
      makeAuthedRequest(`v1/settings/ibo-info/name/${contactId}`, {
        method: "PUT",
        body: JSON.stringify(nameData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("account");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  const updateEmail = useMutation(
    ({ contactId, email }) =>
      makeAuthedRequest(`v1/settings/ibo-info/email/${contactId}`, {
        method: "PUT",
        body: JSON.stringify({ email }),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("account");
        queryClient.invalidateQueries("issues");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  const updatePhrase = useMutation(
    ({ phraseData }) =>
      makeAuthedRequest(`v1/settings/ibo-info/phrase`, {
        method: "PUT",
        body: JSON.stringify(phraseData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("account");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );
  const updatePhone = useMutation(
    ({ phoneData, contactId }) =>
      makeAuthedRequest(`v1/settings/ibo-info/phone/${contactId}`, {
        method: "PUT",
        body: JSON.stringify(phoneData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("account");
        queryClient.invalidateQueries("issues");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  const updatePassword = useMutation(
    ({ passwordData }) =>
      makeAuthedRequest(`v1/settings/password`, {
        method: "PUT",
        body: JSON.stringify(passwordData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("password");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  const createSecondaryContact = useMutation(
    (secondaryContactData) =>
      makeAuthedRequest(`v1/settings/secondary-contact`, {
        method: "POST",
        body: JSON.stringify(secondaryContactData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("secondary-contact");
        queryClient.invalidateQueries("usersInfo");
        queryClient.invalidateQueries("account");
        queryClient.invalidateQueries("issues");
      },
      // onError: (err) => {
      //   console.error(err);
      // },
    }
  );

  return {
    updateName,
    updateEmail,
    updatePhrase,
    updatePhone,
    updatePassword,
    createSecondaryContact,
  };
};
